module.exports = __webpack_public_path__ + "static/media/logo_acer.02379f9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_acer.jpg
// module id = 1841
// module chunks = 0